/* Publish by EComposer at 2026-10-16 09:22:28*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-osbhbc8y6gi"]=  window.__ectimmers["ecom-osbhbc8y6gi"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-osbhbc8y6gi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-osbhbc8y6gi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-28cw5fuc49g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-28cw5fuc49g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yt9250bbi1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yt9250bbi1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-imot49szkc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-imot49szkc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4safzghpype').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4safzghpype', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n30qpwwxo38').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n30qpwwxo38', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-anqhy1tajj7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-anqhy1tajj7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-00d2v6pspbulf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-00d2v6pspbulf', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-gay029rf4t7"]=  window.__ectimmers["ecom-gay029rf4t7"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const s=t.querySelector(".ecom__element--button");if(!s)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,n=1e3;window.__ectimmers["ecom-gay029rf4t7"]["yl7myra1d"] = setInterval(function(){s.classList.add("animated"),setTimeout(function(){s.classList.remove("animated")},n)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},s);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const n=e.getAttribute("href"),r=e.getAttribute("target");n&&n!=="#"&&n!=="javascript:void(0)"&&(r==="_blank"?window.open(n,"_blank"):setTimeout(function(){window.location.href=n},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-gay029rf4t7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gay029rf4t7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6267eqifbq7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6267eqifbq7', settings: {},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}